import { APP_BASE_HREF, LocationStrategy } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Injectable,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
    ViewEncapsulation,
    ChangeDetectorRef,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '@app/_core/services/app.service';
import { DialerService } from '@app/_core/services/dialer.service';
import { ManagerService } from '@app/_core/services/manager.service';
import { QueuesService } from '@app/_core/services/queues.service';
import { TmQueueService } from '@app/_core/services/tm-queue.service';
import { TransferWindowComponent } from '@app/pages/common/transfer-window/transfer-window.component';
import { CurrentStatusMessageComponent } from '@app/pages/dashboard/current-status-message/current-status-message.component';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { MainControllerComponent } from 'src/app/pages/queue/dialer/MainController.component';
import { ConfirmDialogComponent } from 'src/app/pages/common/confirm-dialog/confirm-dialog.component';
import { WebStorageService } from '@app/_core/services/webstorage.service';
//import { LoaderService } from '@app/_core/services/loader.service';
let onHold: boolean = false;
@Injectable({ providedIn: 'root' })
@Component({
  selector: 'app-dialer',
  templateUrl: './dialer.component.html',
  styleUrls: ['./dialer.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DialerComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild('dialog') dialog;
  @ViewChild('phoneInput') phoneInputRef!: ElementRef;
  @Output() endCall: EventEmitter<any> = new EventEmitter<any>();
  @Output() muteMic: EventEmitter<any> = new EventEmitter<any>();
  @Output() toggleHold: EventEmitter<any> = new EventEmitter<any>();
  @Output() hidemodal: EventEmitter<any> = new EventEmitter<any>();
  @Output() conferenceWindowOpened: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() showDialer: any;
  @Input() callStatus: any;
  @Input() phoneNo: any;
  @Input() waitingForInboundCall = false;
  @Input() dialerMessage = '';
  //public  onHold: boolean = false;
  //onHold: boolean = false;
  visible: boolean = true;
  position: any = 'topright';
  connections = false;
  IsSubmitted = false;
  callCompleted = false;
  menuName: any;
  modalRef?: BsModalRef;
  conferenceModalRef?: BsModalRef;
  keypad: any;
  callDuraton: any = 0;
  device: any;
  queueId: any;
  isCallEnabled: boolean = false;
  callDisconnected: boolean = false;
  callConnected: boolean = false;
  showCallDuration: boolean = false;
  showCallDialer: boolean = false;
  formattedCallDuration: any;
  isAutomatedQueue: boolean = false;
  isMicMute: boolean;
  OutBoundNumber: string;
  callID: string;
  IsInboundCall: boolean;
  holdbtn_enabled: boolean = true;
  mutebtn_enabled: boolean = true;
  hangupbtn_enabled: boolean = true;
  transferbtn_enabled: boolean = true;
  conferencebtn_enabled: boolean = true;
  dialbtn_enabled: boolean = true;
  isTransferwindowActive: boolean = false;
  isConferencewindowActive: boolean = false;
  isKeyboardActive: boolean = false;

  queueType: any;
  contactNumList: any;
  numberPad = [
    { number: '1' },
    { number: '2', digit: 'ABC' },
    { number: '3', digit: 'DEF' },
    { number: '4', digit: 'GHI' },
    { number: '5', digit: 'JKL' },
    { number: '6', digit: 'MNO' },
    { number: '7', digit: 'PQRS' },
    { number: '8', digit: 'TUV' },
    { number: '9', digit: 'WXYZ' },
    { number: '*' },
    { number: '0', digit: '*' },
    { number: '#' },
  ];
  callTimer: any;

 // Hold timing fields
 holdTimer: any;
 holdStartTimestamp: number = 0;
 accumulatedHoldSeconds: number = 0;
 formattedHoldDuration: string = '0:00';
 statusMenuTimeout: any;

  callType: any = { queue: '', dialerType: '' };
  deviceReady: boolean = false;

  callerStatus: NodeJS.Timeout;
  activityId: any;
  interactionID: any;
  display: any = 'none';
  showUserMenuDropdown: boolean = false;
  filterVal: any = '';
  infQueueDetail: any;
  EnableFreePhone: boolean = false;
  @Input() ReadOnly: boolean;
  @Output() showCallDialerOut: EventEmitter<boolean> = new EventEmitter<boolean>();
  isFreeDialer: boolean = false;
  constructor(
    private router: Router,
    public queueService: QueuesService,
    private modalService: BsModalService,
    @Inject(APP_BASE_HREF) public baseHref: string,
    private url: LocationStrategy,
    private activatedRoute: ActivatedRoute,
    private tmQueueService: TmQueueService,
    private appService: AppService,
    private dailerService: DialerService,
    private managerService: ManagerService,
    private mainController: MainControllerComponent,
    private confirmDialogComponent: ConfirmDialogComponent,
    private webStorageService:WebStorageService,
    //private loaderService: LoaderService
      private cdr: ChangeDetectorRef,
  ) {
    // this.appService.isCaseLocked.subscribe(res=>{
    //   console.log(res,'res')
    //   if(res == true){
    //     this.ReadOnly = res
    //   }else{
    //     this.releaseLocks();
    //   } 
    //  })
    this.dailerService.IsFreeDialer.subscribe(value => {
      this.isFreeDialer = value;
    });
    this.appService.selectedQueueId.subscribe(queueId => {
      this.queueId = queueId;
    });
    this.appService.selectedQueueType.subscribe((type: any) => {
      this.resetDialerPanels();
      if (type == 'Inbound' || type == 'Blended') {
        this.IsInboundCall = true;
        this.OutBoundNumber = '';
        this.isCallEnabled = false;
      } else if (type == 'Outbound' || type == 'Search') {
        this.IsInboundCall = false;
        this.getExternalNumbersByActivity();
      }
    });
    this.hidemodal.subscribe(val => {
      if (this.modalRef) {
        //To hide the transfer window
        //this.modalRef.hide();
      }
    });
    this.toggleHold.subscribe(val => {
      if (!val.val) {
        onHold = false;
          if (val.shouldcallapi) {
              this.dailerService.setResumeCall(true);
          }
          else {
              this.mainController.onHold = false;
          }
        this.dailerService.setOnHold(false);

        this.dailerService.setStopHoldTimer(true);
        //console.log('call on resume: ', onHold);
      } else {
        onHold = true;
        this.dailerService.setOnHold(true);
        this.dailerService.setResumeCall(false);
        //console.log('call on hold: ', onHold);
      }
    });
    this.endCall.subscribe(msg => {
      //console.log('endCall Emit');
      this.hangUp();
      this.connections = false;
      this.showDialer = false;
      //this.waitingForInboundCall = false;
      this.callDisconnected = true;
      this.dailerService.setShowDialer(false);
      clearInterval(this.callTimer);
      // this.eSubmitHandler();
    });
    //this.dailerService.callEnded.subscribe((val: boolean) => {
    //  console.log('CALL_Ended dialer Emit');
    //  if (val) this.hangUp();
    //});

    //this.CallTransfer_hide.subscribe(val => {

    //    console.log('dialer call transfer Emit', val);
    //    //this.bsModalRef.hide();
    //    //this.initdialog();
    //    this.modalRef

    //});
  }
  // ngAfterViewInit(): void {
  //   this.deviceReady=false;
  //   this.connections=true;
  //   this.inboundCall=false;
  // }

  ngOnChanges(changes: any): void {

    this.showDialer = changes?.showDialer?.currentValue;
    //console.log('ngOnChanges ', changes?.showDialer?.currentValue);
    this.callConnected = changes?.callConnected?.currentValue;
  }

  ngOnDestroy(): void {
    this.callTimer && clearInterval(this.callTimer);
    this.holdTimer && clearInterval(this.holdTimer);
    this.statusMenuTimeout && clearTimeout(this.statusMenuTimeout);
  }
  releaseLocks() {
    if (!this.ReadOnly) this.tmQueueService.releaseLocks().subscribe();
  }
  getExternalNumbersByActivity() {
    const queueID = this.queueService.getselectedQueueId();
    this.tmQueueService.getExternalNumbersByActivity(queueID).subscribe(data => {
      this.contactNumList = [];
      if (data.Response.Data.length > 0) {
        data.Response.Data.forEach((obj: any) => {
          if (obj.ContactListEnabled)
            this.contactNumList.push({ id: obj.ID, contactName: obj.Name, contactNumber: obj.Number });
        });
        if (this.filterVal) this.contactNumList = this.filterItems(this.contactNumList, this.filterVal);
      }
    });
  }
  filterItems(arr, query) {
    return arr.filter(el => el.contactName.toLowerCase().includes(query.toLowerCase()));
  }

  ngOnInit(): void {
    //console.log(this.ReadOnly);
    this.dailerService.setHoldCallDuration('0:00');
    this.dailerService.accumulatedHoldSeconds.subscribe(val =>{
      this.accumulatedHoldSeconds = 0;
    });
    this.dailerService.phoneNo.subscribe(val => {
      this.OutBoundNumber = val;
    })
    this.dailerService.stopHoldTimer.subscribe(val => {
      if (val) { 
        clearInterval(this.holdTimer);
        this.accumulatedHoldSeconds = 0;
        // this.formattedHoldDuration = '0:00';
        // this.dailerService.setHoldCallDuration(this.formattedHoldDuration);
        this.holdTimer = undefined;
      }
    });

    this.appService.infoCurrentQueue.subscribe(response => {
      if (response) {
        this.infQueueDetail = response;
        if (this.menuName !== 'Inbound') {
          this.EnableFreePhone = this.infQueueDetail.EnableFreePhone;
        }
        else {
          this.EnableFreePhone = true;
        }
        this.dialerVisibility()
        //this.dailerService.setEnableFreeDialer(this.EnableFreePhone)
      }
    });

    this.tmQueueService.showdialerstatusmenu.subscribe(val => {
      if (val?.showstatusmenu) {
        this.showstatusMenu();
        this.tmQueueService.setshowdialerstatusmenu({ showstatusmenu: false })
      }
    });

    this.tmQueueService.startOutboundCall.subscribe(val => {
      if (val?.status) {
        this.dailerService.setPhoneNo(val?.OutBoundNumber);
        this.OutBoundNumber = val?.OutBoundNumber;
        this.checkCaseDetailFreeDial();
        this.StartOutboundCall('FreeDial');
        this.tmQueueService.setstartOutboundCall({ status: false, OutBoundNumber: '' });
      }
    });

    // this.connections = true;
    //console.log('this.url.path()', this.url.path());
    //this.dailerService.setUserStatus("waiting for call (Ready)");

    //this.appService.setUserStatus(6, this.queueId);
    this.dailerService.showCustomDialer.subscribe((val: any) => {
      // console.log('showCustomDialer val', val);
      //this.showDialer = val;
      if (val) this.showDialerPanel(val);
    });
    this.queueService.notifyObservable$.subscribe(res => {
      //console.log(res);
      if (res.refresh) {
        this.menuName = res.menuName;
        //this.fakeApiCall(res.menuName);
        //console.log('this.menuName', this.menuName);
        if (res.menuName === 'Inbound' || res.menuName === 'Progressive') {
          this.visible = true;
          this.connections = true;
          this.deviceReady = false;
          this.dailerService.setIsFreeDialer(false);
          //if (this.activatedRoute.snapshot.url.some(url => url.path.includes('Inbound'))) {
          //console.log("It's inbound queue..");

          this.EnableFreePhone = true;

          //this.activatedRoute.queryParams.subscribe(params => { \
          //});
          //}

          //this.dailerService.waitingForInboundCall.subscribe((val: boolean) => {
          //  //console.log("waitingForInboundCall dailer val", val);
          //  this.waitingForInboundCall = val;
          //  //if(this.waitingForInboundCall){
          //  //this.connections = true;
          //  //this.dailerService.setConnections(val);
          //  //}
          //});
          this.releaseLocks();



          this.dailerService.showDialer.subscribe((val: boolean) => {
            // console.log('showDialer val', val);
            this.showDialer = val;
          });

          this.dailerService.phoneNo.subscribe((val: string) => {
            this.phoneNo = val;
          });
          this.dailerService.dialerMessage.subscribe((val: string) => {
            this.dialerMessage = val;
          });
          this.dailerService.deviceReady.subscribe((val: boolean) => {
            this.deviceReady = val;
          });
          this.dailerService.callConnected.subscribe((val: boolean) => {
            this.callConnected = val;
            if (val) {
              this.dailerService.setCallStatus('Connected');
              //this.dailerService.setUserStatus('On Call (Active)');
              //this.appService.setUserStatus(5, this.queueId);
              this.callDuraton = 0;
              clearInterval(this.callTimer);
              this.startTimer();
              this.connections = false;
              this.resetdialerbuttons();
            }
          });
          this.dailerService.showTimer.subscribe((val: boolean) => {
            this.callConnected = val;
            if (val) {
              clearInterval(this.callTimer);
              this.startTimer();
            }
          });
          //this.dailerService.showCallDuration.subscribe((val: boolean) => {
          //    this.showCallDuration = val;
          //});
          this.dailerService.callDisconnected.subscribe((val: boolean) => {
            this.callDisconnected = val;
            if (val) {
              //if (!this.dailerService.getsoftphoneCancelledStatus()) this.appService.setUserStatus(8, this.queueId);
              if (this.isFreeDialer) {
                  if (!this.IsSubmitted && this.callID && !this.dailerService.getIsCaseDetailFreeDial() && this.dailerService.getIsFreeDialer()) {
                  this.submitCall();
                  this.IsSubmitted = true;
                }
                if (!this.dailerService.getIsCaseDetailFreeDial())
                  this.queueService.SetDisableHeader(false);
                //this.appService.setUserStatus(6, this.queueId);
                this.dailerService.setResetCallSummary(true);
                //this.dailerService.setCustomShowDialer(false);
              }
              else {
                this.connections = false;
                this.showDialer = false;
                //this.waitingForInboundCall = false;
                this.callDisconnected = true;
                this.dailerService.setShowDialer(false);
                if (this.conferenceModalRef) {
                  this.conferenceModalRef.hide();
                }
                this.queueService.setCaseDetails_ENABLECONTROLS(false);
                clearInterval(this.callTimer);
                if (this.isTransferwindowActive) {
                  this.hideTransferWindow();
                }
              }
            }
          });

          this.dailerService.connections.subscribe((val: boolean) => {
            this.connections = val;
          });
        } else if (res.menuName === 'Outbound' || res.menuName === 'Search') {
          this.visible = true;
          this.deviceReady = false;
          // this.connections = false;
          this.dailerService.resetTimer.subscribe((val: boolean) => {
            if (val) {
              this.callDuraton = 0;
              clearInterval(this.callTimer);
            }
          });
          // this.dailerService.showDialer.subscribe((val: boolean) => {
          //   console.log('showDialer val', val);
          //   this.showDialer = val;
          // });
          this.dailerService.showTimer.subscribe((val: boolean) => {
            this.callConnected = val;
            if (val) {
              clearInterval(this.callTimer);
              this.startTimer();
            }
          });
          //this.dailerService.showCallDuration.subscribe((val: boolean) => {
          //    this.showCallDuration = val;
          //});
          this.dailerService.callEnded.subscribe((val: boolean) => {
            if (val) {
              //console.log(' dailerService CALL_Ended dialer Emit');
              this.connections = false;
              this.showDialer = false;

              this.callDisconnected = true;
              //this.dailerService.setShowDialer(false);
              //this.dailerService.setCallDisconnected(true);
              clearInterval(this.callTimer);
              //console.log('call ended');
            }
            // if (val) this.hangUp();
          });
          //this.dailerService.showCustomDialer.subscribe((val: any) => {
          //  //console.log('showCustomDialer val', val);
          //  //this.showDialer = val;
          //  if (val) this.showDialerPanel(val);
          //});
          this.dailerService.phoneNo.subscribe((val: string) => {
            this.phoneNo = val;
          });
          this.dailerService.dialerMessage.subscribe((val: string) => {
            this.dialerMessage = val;
          });
          this.dailerService.deviceReady.subscribe((val: boolean) => {
            this.deviceReady = val;
          });

          this.dailerService.callConnected.subscribe((val: boolean) => {
            this.callConnected = val;
            if (val) {
              this.dailerService.setCallStatus('Connected');
              //this.dailerService.setUserStatus('On Call (Active)');
              // this.appService.setUserStatus(5, this.queueId);
              clearInterval(this.callTimer);
              this.startTimer();
              this.connections = false;
              this.resetdialerbuttons();
            }
          });
          this.dailerService.resetCallSummary.subscribe((val: boolean) => {
            if (val) {
              this.EnableDialOption();
            }
          });

          this.dailerService.callDisconnected.subscribe((val: boolean) => {
            this.callDisconnected = val;
            if (val) {
              //submit call for free dialer-start
              if (this.isFreeDialer && !this.IsInboundCall) {
                  if (!this.IsSubmitted && this.callID && !this.dailerService.getIsCaseDetailFreeDial() && this.dailerService.getIsFreeDialer()) {
                  this.submitCall();
                  this.IsSubmitted = true;
                }
                if (!this.dailerService.getIsCaseDetailFreeDial())
                  this.queueService.SetDisableHeader(false);
                //this.appService.setUserStatus(6, this.queueId);
                this.dailerService.setResetCallSummary(true);
                //this.dailerService.setCustomShowDialer(false);
              } else {
                // if (this.tmQueueService.getisCallConnected()) {
                //Check this is customer call not internal transfer, then need to update as post-call status
                // console.log('outbound calldisconnected called');
                //this.appService.setUserStatus(8, this.queueId);
                // }
              }

              //submit call for free dialer-end
              this.dailerService.setCallDuration(this.callDuraton);

              this.connections = false;
              this.showDialer = false;
              //this.waitingForInboundCall = false;
              this.callDisconnected = true;
              this.queueService.setCaseDetails_ENABLECONTROLS(false);
              this.dailerService.setShowDialer(false);
              this.dailerService.setHideTransferDialogWindow(true);
              if (this.conferenceModalRef) {
                this.conferenceModalRef.hide();
              }
              this.dailerService.setCustomShowDialer(false);
              clearInterval(this.callTimer);
              //this.dailerService.setisOutboundCallStarted({ isOutboundCallConnected: false, data: '' });
              // if(!this.IsInboundCall)
              // setTimeout(() => {
              //   this.callDisconnected = false;
              //   this.isCallEnabled=false;
              // }, 3000);
            }
          });

          this.dailerService.connections.subscribe((val: boolean) => {
            this.connections = val;
          });
        } else {
          this.dailerService.setConnections(false);
        }
      }
    });
    // this.fakeApiCall("Inbound");
    this.keypad = false;
    this.appService.activityId.subscribe(value => {
      this.activityId = value;
    });
  }

  showKeypad(isKeyboardActive) {
    this.isKeyboardActive = !isKeyboardActive;


    this.keypad = !this.keypad;
    //console.log(this.keypad);
  }

  onNumberPadBtnClick(value) {
    var tone;
    //AWS Migration - ONV-1456 ( Hardcoded s3bucket name of AWS environment )
    switch (value) {
      case "#":
        tone = new Audio("https://common.cts-connect.com/Audio/pound.wav");
        break;
      case "*":
        tone = new Audio("https://common.cts-connect.com/Audio/star.wav");
        break;
      default:
        tone = new Audio("https://common.cts-connect.com/Audio/" + value + ".wav");
    }
    tone.play();

    this.appService.setNumberpadValue(value);
    // this.numberPadKeyPressedHandler(value)
  }


  resetdialerbuttons() {
    this.holdbtn_enabled = true;
    this.mutebtn_enabled = true;
    this.hangupbtn_enabled = true;
    this.transferbtn_enabled = true;
    this.conferencebtn_enabled = true;
    this.dialbtn_enabled = true;
  }

  resetDialerPanels() {
    this.connections = false;
    this.showDialer = false;
  }

  showDialerPanel(data: any) {
    if (!data?.CustomControlEnabled) {
      this.showDialer = data?.showDialer ?? true;

      this.holdbtn_enabled = true;
      this.mutebtn_enabled = true;
      this.hangupbtn_enabled = true;
      this.transferbtn_enabled = true;
      this.conferencebtn_enabled = true;
      this.dialbtn_enabled = true;
    } else {
      this.dailerService.setCallStatus(data.dialerStatusText ?? '');
      this.showDialer = data.showDialer ?? true;
      this.holdbtn_enabled = data.holdBtn_enabled ?? true;
      this.mutebtn_enabled = data.muteBtn_enabled ?? true;
      this.hangupbtn_enabled = data.hangUpBtn_enabled ?? true;
      this.transferbtn_enabled = data.transfersBtn_enabled ?? true;
      this.conferencebtn_enabled = data.conferenceBtn_enabled ?? true;
      this.dialbtn_enabled = data.keypadBtn_enabled ?? true;

      if (this.conferenceModalRef && !this.conferencebtn_enabled) {
        this.conferenceModalRef.hide();
      }

      if (data.resetbuttonstodefault) {
        this.isMicMute = false;
        this.isTransferwindowActive = false;
        onHold = false;
      }
    }
    this.cdr.detectChanges();
  }

  showstatusMenu() {
    if (this.dailerService.getIsStatusModalOpen()) {
      return;
    }
    if (this.tmQueueService.getisBlendedQueue()) {
      this.confirmDialogComponent
        .confirmdialog('', 'This may result in an abandoned' + this.mainController.getInteractionName() + '. Are you sure you would like to cancel?', 'Yes', 'No')
        .then((confirmed) => {
          if (confirmed) {
            if (this.dailerService.getIsStatusModalOpen()) {
              return;
            }
            const initialState = { ShowOkButton: false };

            const config: ModalOptions = {
              class: 'status-menu',
              backdrop: 'static',
              keyboard: false,
              initialState,
            };
            this.dailerService.setIsAgentStatusChangeRequired(true);
            this.modalRef = this.modalService.show(CurrentStatusMessageComponent, config);
            //this.connections = !this.connections;
            this.connections = false;
            this.showDialer = false;
            this.mainController.setAllDialerWindowStatus(false, false, false);
            this.dailerService.setDialerCancel(true);
            this.dailerService.setCallDisconnected(false);


          }


        })
        .catch(() =>
          console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
        );
    }
    else {
        this.dailerService.setDialerCancel(true);
      const initialState = { ShowOkButton: false };

      const config: ModalOptions = {
        class: 'status-menu',
        backdrop: 'static',
        keyboard: false,
        initialState,
      };
      this.dailerService.setIsAgentStatusChangeRequired(true);
      //this.modalRef = this.modalService.show(CurrentStatusMessageComponent, config);
        this.statusMenuTimeout = setTimeout(() => {
            if (this.dailerService.getIsStatusModalOpen()) {
              return;
            }
            this.modalRef = this.modalService.show(CurrentStatusMessageComponent, config);
            this.cdr.detectChanges();
        }, 0);
      //this.connections = !this.connections;
      //this.connections = false;
      //this.showDialer = false;
      this.mainController.setAllDialerWindowStatus(false, false, false);
      
      //this.dailerService.setCallDisconnected(false);
      //this.modalRef.content.event.subscribe((result: any) => {
      //  // this.cols = result.data;
      //  // this.dataToDisplay = this.applyColumnFilters(this.filteredData);
      //});
    }

  }

  hangUp() {
    this.mainController.setcallTransferred(false);
    this.accumulatedHoldSeconds = 0;
    clearInterval(this.holdTimer);
    var iscallhold = this.mainController.onHold;
    if (iscallhold) {
      this.mainController.toggleHold('', undefined);
    }

    //this.endCall.emit();
    this.dailerService.setIsTransferCallRejected(false);
    //this.dailerService.setUserStatus('Pre-call (Ready)');
    //this.appService.setUserStatus(7, this.queueId);
    this.connections = false;
    this.showDialer = false;
    //this.waitingForInboundCall = false;
    this.callDisconnected = true;
    this.dailerService.setShowDialer(false);
    this.dailerService.setCallDisconnected(true);
    //this.dailerService.setcallEnded(true);
    if (!iscallhold) {
      this.mainController.endCall_main(false, false);
    }
    //this.dailerService.setWaitingForInboundCall(true);
    this.queueService.setCaseDetails_ENABLECONTROLS(false);
    clearInterval(this.callTimer);
    //console.log('call ended');
    if (this.modalRef) {
      //To hide the transfer window
      this.modalRef.hide();
    }


  }
  focusInput() {
    //console.log(this.phoneInputRef)
    setTimeout(() => {
      this.phoneInputRef?.nativeElement.focus();
    });
  }

  mute(isMicMute) {
    this.isMicMute = !isMicMute;
    this.dailerService.setMuteMic(this.isMicMute);
    //console.log('isMicMute', this.isMicMute);
  }

  unmute() {
    this.isMicMute = false;
    this.dailerService.setMuteMic(this.isMicMute);
    //console.log('isMicMute', this.isMicMute);
  }

  fakeApiCall(menuName) {
    //this.dailerService.setUserStatus('Waiting for call (Ready)');
    setTimeout(async () => {
      this.deviceReady = true;
      if (menuName == 'Inbound') {
        this.waitingForInboundCall = true;

        // await setTimeout(async ()=>{
        //   this.inboundCall=false;
        //   this.connections=false;
        //   this.callCompleted=false;
        //   this.dailerService.setUserStatus("On Call (Active)");
        //   await setTimeout(()=>{
        //     // this.callCompleted=true;
        //     // this.dailerService.setUserStatus("pre-call (Ready)");
        //   },1000)
        // },1000)
      } else {
        this.dailerService.setUserStatus('Pre-call (Ready)');
        this.callCompleted = false;
        this.waitingForInboundCall = false;
        this.connections = false;
        await setTimeout(() => {
          this.callCompleted = true;
        }, 1000);
      }
      // this.dailerService.setUserStatus("pre-call (Ready)");
    }, 1000);
  }

  showConferenceParticipant(isConferencewindowActive) {
    if (!this.queueService.getistransferProcessing()) {
      this.isConferencewindowActive = !isConferencewindowActive;
      this.conferenceWindowOpened.emit(this.isConferencewindowActive);
      const initialState = {
        // cols: this.cols,
        // colName: colName
        ShowParticipantList: true,
      };

      const config: ModalOptions = {
        class: 'transfer-window Conference-window',
        backdrop: 'static',
        keyboard: false,
        initialState,
      };

      if (this.isConferencewindowActive) {
        // this.isConferencewindowActive = false;
        this.dailerService.setHideTransferDialogWindow(false);
        this.conferenceModalRef = this.modalRef = this.modalService.show(TransferWindowComponent, config);
        this.modalRef.onHidden.subscribe(
          data => {
            // on close
            this.isConferencewindowActive = false;
            this.conferenceWindowOpened.emit(this.isConferencewindowActive);
          },
          error => {
            // on error/dismiss
            this.isConferencewindowActive = false;
            this.conferenceWindowOpened.emit(this.isConferencewindowActive);
          }
        );
      } else {
        this.dailerService.setHideTransferDialogWindow(true);
      }
    }

    //this.transferbtn_enabled = false;
    //this.modalRef.content.event?.subscribe((result: any) => {
    //  // this.cols = result.data;
    //  // this.dataToDisplay = this.applyColumnFilters(this.filteredData);
    //});
  }

  transferCall(isTransferwindowActive) {
   this.queueService.setTransferInteractionID(null) 
    this.isTransferwindowActive = !isTransferwindowActive;
    const initialState = {
      // cols: this.cols,
      // colName: colName
      ShowParticipantList: false,
    };

    const config: ModalOptions = {
      class: 'transfer-window-modal modal-lg',
      backdrop: 'static',
      keyboard: false,
      initialState,
    };

    if (this.isTransferwindowActive) {
      // this.isTransferwindowActive = false;
      this.dailerService.setHideTransferDialogWindow(false);
      this.modalRef = this.modalService.show(TransferWindowComponent, config);
      this.modalRef.onHidden.subscribe(
        data => {
          // on close
          this.isTransferwindowActive = false;
        },
        error => {
          // on error/dismiss
          this.isTransferwindowActive = false;
        }
      );
    } else {
      this.dailerService.setHideTransferDialogWindow(true);
    }
    //this.transferbtn_enabled = false;
    //this.modalRef.content.event?.subscribe((result: any) => {
    //  // this.cols = result.data;
    //  // this.dataToDisplay = this.applyColumnFilters(this.filteredData);
    //});
  }

  startTimer() {
    //this.callDuraton = 0;
    //this.callTimer = setInterval(() => {
    //  this.callDuraton++;
    //  this.formattedCallDuration = this.formatCallDuration(this.callDuraton);
    //}, 1000);
  }



  formatCallDuration(seconds) {
    const hoursLeft = Math.floor(seconds / 3600);
    const min = Math.floor((seconds - hoursLeft * 3600) / 60);
    let secondsLeft = seconds - hoursLeft * 3600 - min * 60;
    secondsLeft = Math.round(secondsLeft * 100) / 100;
    let answer = hoursLeft < 10 ? '0' + hoursLeft : hoursLeft;
    answer += ':' + (min < 10 ? '0' + min : min);
    answer += ':' + (secondsLeft < 10 ? '0' + secondsLeft : secondsLeft);
    return answer;
  }

  getonHold() {
    return onHold;
  }

  // setHoldTimer(){
  //   clearInterval(this.holdTimer);
  //   this.accumulatedHoldSeconds = 0;
  //   this.formattedHoldDuration = '0:00';
  //   this.dailerService.setHoldCallDuration(this.formattedHoldDuration);
  //   this.holdTimer = undefined;
  // }

    togglehold() {
        if (onHold) {
            // resume from hold
            onHold = false;
            this.dailerService.setResumeCall(true);
            this.dailerService.setOnHold(false);

            // stop hold timer and accumulate
            if (this.holdStartTimestamp) {
                const elapsed = Math.floor((Date.now() - this.holdStartTimestamp) / 1000);
                this.accumulatedHoldSeconds += elapsed;
                this.holdStartTimestamp = 0;
            }
            clearInterval(this.holdTimer);
            this.holdTimer = undefined;

            // final formatted value
            let duration = this.formatCallDuration(this.accumulatedHoldSeconds).toString();
            let splitedValues = duration.split(':');
            if (splitedValues.length === 3) {
              const [h, m, s] = splitedValues;
              // If hours are "00", show only mm:ss; otherwise keep full
              this.formattedHoldDuration = h === '00' ? `${Number(m).toString()}:${s}` : `${Number(h).toString()}:${Number(m).toString()}:${s}`;
            }
            this.cdr.detectChanges();
        } else {
            // put call on hold
            onHold = true;
            this.dailerService.setOnHold(true);
            this.dailerService.setResumeCall(false);

            // start hold timer
            this.holdStartTimestamp = Date.now();
            // initialize display with accumulated value (in case of multiple holds)
            this.formattedHoldDuration = this.formatCallDuration(this.accumulatedHoldSeconds).toString();
            clearInterval(this.holdTimer);
            this.holdTimer = setInterval(() => {
                const elapsed = this.accumulatedHoldSeconds + Math.floor((Date.now() - this.holdStartTimestamp) / 1000);
                let duration = this.formatCallDuration(elapsed).toString();
                let splitedValues = duration.split(':');
                if (splitedValues.length === 3) {
                  const [h, m, s] = splitedValues;
                  // If hours are "00", show only mm:ss; otherwise keep full
                  this.formattedHoldDuration = h === '00' ? `${Number(m).toString()}:${s}` : `${Number(h).toString()}:${Number(m).toString()}:${s}`;
                }
                this.dailerService.setHoldCallDuration(this.formattedHoldDuration);
                this.cdr.detectChanges();
            }, 1000);
            //console.log('call on hold: ', onHold);
        }
    }
  //hold() {
  //  this.onHold = true;
  //  this.dailerService.setOnHold(true);
  //  this.dailerService.setResumeCall(false);
  //  console.log('call on hold: ', this.onHold);
  //}

  //resume() {
  //  this.onHold = false;
  //  this.dailerService.setResumeCall(true);
  //  this.dailerService.setOnHold(false);
  //  console.log('call on hold: ', this.onHold);
  //}


  StartOutboundCall(type: any) {
    //var timeToDelay = this.mainController.CheckLastCallCompletedTimeBeforeCall();
    //console.log('TimetoDelaycall', timeToDelay);
    //(async () => {
    //    console.log('Before delay', new Date());
    //    this.loaderService.display(true);
    //    await this.delay(timeToDelay); // 1-second delay
    //    console.log('After delay', new Date());
    //    this.loaderService.display(false);
    if (type == 'CreateCall') {
      this.OutBoundNumber = this.dailerService.getPhoneNo();
      this.dailerService.setIsFreeDialer(false);
    } else this.dailerService.setIsFreeDialer(true);
    this.dailerService.setResetTimer(true);
    this.IsSubmitted = false;
    this.dailerService.setCallStatus('Dialing');
    this.mainController.isSubmitfailurePopupdisplayed = false;
    this.mainController.setCallInProgressStatus(true);
    this.mainController.setCallPromptControlsActiveStatus(true);
    // Use these 2 lines to test the outbound call screens without actually making a call in local
    // this.showDialer = true;
    // this.dailerService.setShowDialer(true);
    //this.queueId

    if (!this.mainController.getisCaseDetailStatus() && type != 'CreateCall') {
      this.mainController.setEnterRecord(null);
    }

    this.tmQueueService.startCall(this.OutBoundNumber, this.queueService.getselectedQueueId()).subscribe((result: any) => {
      if (result?.Response?.Data?.Params?.CallID != null) {
        this.callID = result.Response.Data.Params.CallID;
        this.showDialer = true;
          if (this.dailerService.getIsFreeDialer()) {//this.dailerService.getIsCaseDetailFreeDial()
              this.queueService.setChildCallID(this.callID);
              console.log('dialer component set child id', this.callID);
          }
          else {
              this.queueService.setCallID(this.callID);
              console.log('dialer component set parent id', this.callID);
          }
        
        //console.log('Outbound call start CALLID:' + this.queueService.getCallID());
        this.dailerService.setDeviceReady(false);
        this.dailerService.setConnections(false);
        this.dailerService.setShowDialer(true);
        this.dailerService.setCallConnected(false);
        this.mainController.setisOutboundCallStarted({
          isOutboundCallConnected: true,
          data: result.Response.Data,
          OutBoundNumber: this.OutBoundNumber,
        });
        //this.dailerService.setisOutboundCallStarted({
        //  isOutboundCallConnected: true,
        //  data: result.Response.Data,
        //  OutBoundNumber: this.OutBoundNumber,
        //});
        if (this.isFreeDialer && this.dailerService.getIsCaseDetailFreeDial()) {
          let userdata = this.dailerService.getCurrentUserRecord()
          var userid = (this.mainController.getcurrentRecordUserID() == 'null' || this.mainController.getcurrentRecordUserID() == null || this.mainController.getcurrentRecordUserID() == '') ? (userdata?.UserID ?? -1) : this.mainController.getcurrentRecordUserID();
          //this.setCurrentCallee(userdata?.UserID ?? -1 )
          this.setCurrentCallee(userid ?? -1)
        }
        else if (!this.isFreeDialer) {
          var userid = (this.queueService.getOutboundRecordUserID() == 'null' || this.queueService.getOutboundRecordUserID() == null) ? -1 : this.queueService.getOutboundRecordUserID();
          this.setCurrentCallee(userid);
        }

        this.tmQueueService.getUpdate(this.callID, '').subscribe((response: any) => {
          if (response.Response.Data?.InteractionID) {
            this.queueService.SetDisableHeader(true);
              
              if (!this.isFreeDialer) {
                  this.interactionID = response.Response.Data?.InteractionID;
                  this.queueService.setInteractionID(this.interactionID)
              }
            if (response.Response.Data.OutgoingCallStatus == 'ringing') {
              this.dailerService.setCallStatus('Ringing');
            } else if (response.Response.Data.OutgoingCallStatus == 'in-progress' && !this.callConnected) {
              this.Showdialer();
              clearInterval(this.callerStatus);
            }
          }
        });
      }
    });

    /* })();*/




  }
  setCurrentCallee(userID: any) {
    this.tmQueueService.setCurrentCallee(this.queueService.getCallID(), userID).subscribe(data => {
      // console.log('setCurrentCallee response', data);
    });
  }
  ValidateOutboundNumber(number: any) {
    this.OutBoundNumber = this.formattedNumber(number.value, '');
    this.dailerService.setPhoneNo(this.OutBoundNumber);

    // Extract only digits for length validation
    const digitsOnly = this.OutBoundNumber.replace(/\D/g, '');

    // Enable call only if we have at least 10 digits
    if (digitsOnly.length >= 10) {
      this.isCallEnabled = true;
    } else {
      this.isCallEnabled = false;
    }
  }

  formattedNumber(number: any, country: any) {
    switch (country) {
      case 'US':
      default:
        number = number.replace(/\D/g, '');
        if (number.charAt(0) == '1') number = number.substring(1);
        if (number.length == 7) return number.substring(0, 3) + '-' + number.substring(3);
        if (number.length == 10)
          return '(' + number.substring(0, 3) + ') ' + number.substring(3, 6) + '-' + number.substring(6);
        if (number.length > 10)
          return (
            '(' +
            number.substring(0, 3) +
            ') ' +
            number.substring(3, 6) +
            '-' +
            number.substring(6, 10) +
            ' x' +
            number.substring(10)
          );
        return number;
    }
  }

  Showdialer() {
    this.dailerService.setDeviceReady(false);
    this.dailerService.setConnections(false);
    // this.dailerService.setWaitingForInboundCall(false);
    this.dailerService.setShowDialer(true);
    this.dailerService.setCallConnected(true); // Show timer
    // this.setCurrentCallee();
    this.appService.setUserStatus(5, this.queueId);

    // Set user status 5
    //this.router.navigate([this.clientAbbreviation + '/Queue/caseDetails']);
  }

  // setCurrentCallee() {
  //   this.tmQueueService.setCurrentCallee(this.callID).subscribe(data => {
  //     console.log('setCurrentCallee response', data);
  //   });
  // }

  setCurrentQueue(queueId) {
    this.tmQueueService.setCurrentQueue(queueId).subscribe(data => {
      //console.log("setCurrentQueue response", data);
    });
  }

  //setUserStatus(statusId, queueId) {
  //  this.tmQueueService.setUserStatus(statusId, queueId).subscribe(data => {
  //    //console.log("setUserStatus response", data);
  //  });
  //}

  EnableDialOption() {
    //if (!this.IsInboundCall) ONV-5558 
    {
      this.OutBoundNumber = this.dailerService.getPhoneNo();
      this.callDisconnected = false;
      if (this.OutBoundNumber) {
        this.isCallEnabled = true;
      } else {
        this.isCallEnabled = false;
      }
      this.mainController.setshowCallDurationWindowStatus();
      // if (!this.dailerService.getIsCaseDetailFreeDial())
      //   this.queueService.SetDisableHeader(false);
      // this.dailerService.setUserStatus('In Queue (Ready)');
      //this.appService.setUserStatus(6, this.queueId);
    }
    this.focusInput();
  }

  getCallStatus() {
    return this.dailerService.getCallStatus();
  }

  hideTransferWindow() {
    if (this.modalRef) {
      //To hide the transfer window
      // this.modalRef.hide();
    }
  }

  openModal() {
    if (this.display === 'none') {
      this.display = 'block';
    } else if (this.display === 'block') {
      this.display = 'none';
    }
  }

  onCloseHandled() {
    this.display = 'none';
  }

  onClearFilterVal() {
    this.filterVal = '';
    this.display = 'none';
  }

  openUserMenu() {
    this.showUserMenuDropdown = !this.showUserMenuDropdown;
  }

  applyFilterByField() {
    this.getExternalNumbersByActivity();
  }

  submitCall() {
    let pl = {
      activityId: this.activityId,
      calleeUserId: this.appService.getIsAddNewUser() ? "-1" : (this.mainController.getcurrentRecordUserID() ?? -1),
      queueId: this.queueService.getselectedQueueId(),
      notes: '',
      callDuration: this.callDuraton,
      enterRecord: '',
      customTYLanguage: null,
      scheduledInteractionID: null,
      voicemailID: null,
      requestType: null,
      requestTypeColor: null,
      visiblefielddata: [],
      appointmentData: null,
      userInformation: null,
      cases: [],
      survey: [],
      disposition: [],
      isFreeDialer: this.isFreeDialer,
      activeController: 'Queue',
      agentHangUp: true,
      //callID: this.callID,
        callID: (this.dailerService.getIsFreeDialer() ? this.queueService.getChildCallID() : this.queueService.getCallID()),
      interactionID: this.interactionID,
      company: this.webStorageService.getItemFromSessionStorage('company')
    };
    if (this.dailerService.IsCaseDetailFreeDial) {
      pl.userInformation = this.dailerService.getCurrentUserRecord();
      
      //let pl2={calleeUserId: pl.userInformation?.UserID}
      //pl={...pl,...pl2}
    }
    // don't comment below method, 
    this.managerService.submitCaseDetails(pl).subscribe((res: any) => {
        // console.log('submitCaseDetails res', res);
        this.queueService.setChildCallID('');
    });
  }

  StartFreeDialOutbound() {
    this.accumulatedHoldSeconds = 0;
    this.dailerService.setHoldCallDuration('0:00');
    this.dailerService.setPhoneNo(this.OutBoundNumber);
    this.checkCaseDetailFreeDial()
    this.StartOutboundCall('FreeDial');
  }

  checkCaseDetailFreeDial() {
    let loc = this.router.url;
    if (loc.toLowerCase().includes("casedetails")) {
      this.dailerService.setIsCaseDetailFreeDial(true);
    }
    else {
      this.dailerService.setIsCaseDetailFreeDial(false);
    }
  }
  StartCallActivity(item: any) {
    this.dailerService.setPhoneNo(item.contactNumber);
    this.OutBoundNumber = item.contactNumber;
    this.checkCaseDetailFreeDial()
    this.StartOutboundCall('FreeDial');
    this.onCloseHandled();
  }

  getShowDialerStatus() {
    this.dialerVisibility()
    return this.mainController.getShowDialerWindowStatus();
  }

  getWaitingForcallStatus() {
    this.dialerVisibility()
    return this.mainController.getWaitingForcallWindowStatus();
  }
  getshowCallDurationStatus() {
    this.dialerVisibility()
    return this.mainController.getshowCallDurationWindowStatus();
  }

  getcallDuratonStatus() {
    this.callDuraton = this.mainController.getcallDuraton();
    return this.callDuraton;
  }
  getformattedCallDurationStatus() {
    this.formattedCallDuration = this.mainController.getformattedCallDuration();
    return this.formattedCallDuration;
  }


  dialerVisibility() {
    if (this.mainController.getWaitingForcallWindowStatus() ||
      this.mainController.getShowDialerWindowStatus() ||
      this.mainController.getshowCallDurationWindowStatus() || this.EnableFreePhone) {
      this.showCallDialerOut.emit(true);
    }
    else {
      this.showCallDialerOut.emit(false);
    }
  }
    getAgentStatus() {
        let status = this.mainController.getAgentStatus();
        return status;
    }
}
